import React, {  useState } from "react";
import { useQueryClient } from '@tanstack/react-query';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Button, Table } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IncreaseIcon from "../../../assets/img/app/Increase.png"
import DecreaseIcon from  "../../../assets/img/app/Decrease.png"
import toast, { Toaster } from "react-hot-toast";
import styled from 'styled-components';

import { Edit2, Trash } from "react-feather";

import {
  useQueryRetrieveProductTransactions,
  useQueryRetrieveInventoryTransactionTypes,
  useMutationDeleteTransaction,
 } from "../../../services/stores/queries";


import { InventoryProduct, Transaction, TransactionType, blankProduct } from "../../../types";
import { formatDateYYYYMMDD } from "../../../helpers/utils";

const InfoCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #edf2f7;
  
  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.span`
  color: #718096;
  font-size: 0.875rem;
  font-weight: 500;
  width: 180px;
`;

const Value = styled.span`
  color: #2d3748;
  font-size: 1rem;
  font-weight: 600;
`;

const StyledTable = styled(Table)`
  width: 100%;
  
  thead tr th {
    background-color: #e2e8f0;  // Light gray background for header
    border-bottom: 2px solid #cbd5e0;
  }

  tbody tr {
    &:hover {
      background-color: #f7fafc;
    }
  }

  th, td {
    padding: 0.75rem;
    vertical-align: middle;
  }
`;

const InventoryProductTransactionCard = (transaction: Transaction) => {
  const theDate = new Date(transaction.date);
  const className = 'table-primary hoverable';
  
  const formatDate = (date: Date) => {
    // Format as "DD MMM" in French
    return date.toLocaleDateString('fr-FR', { 
      day: '2-digit',
      month: 'short'
    });
  }

  const toTimeString = (date: Date) => {
    if (date.getHours() === 0 && date.getMinutes() === 0) 
      return '';
    return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
  }

  const toTransactionIcon = (transaction: Transaction) => {
    if (transaction.transactionType.includes('SPRAY'))
      return DecreaseIcon;
    else if (transaction.transactionType.includes('FERTIGATION'))
      return DecreaseIcon;
    else if (transaction.transactionType.includes('-'))
      return DecreaseIcon;
    else 
      return IncreaseIcon;
  }

  const { 
    data: transactionTypes, 
    error: errorTransactionTypes, 
    isLoading: isLoadingTransactionTypes, 
  } = useQueryRetrieveInventoryTransactionTypes();

  const transactionType = transactionTypes?.find((item: TransactionType) => item.transactionType === transaction.transactionType);


  return (
    <tr className={className} key={transaction.id}>
      <td>
        {formatDate(theDate)}
        <small className="d-block text-muted">{toTimeString(theDate)}</small>
      </td>
      <td>
        <img 
          src={toTransactionIcon(transaction)} 
          alt="icon" 
          style={{width: '15px', height: '15px', marginRight: '15px'}} 
        />
        {transaction.transactionName}
        {transaction.comment}
      </td>
      <td style={{ textAlign: 'right' }}>
        {transaction.quantity} {transaction.uom}
      </td>
    </tr>
  )
}

export const EditProductTransactions = () => {

    const navigate = useNavigate()

    const location = useLocation();
    const initialProduct = location.state ?? blankProduct as InventoryProduct;

    const [product, setProduct] = useState<InventoryProduct>(initialProduct);
    const [showTransferModal, setShowTransferModal] = useState(false);

    const { 
      data: transactions, 
      error: errorTransactions, 
      isLoading: isLoadingTransactions 
    } = useQueryRetrieveProductTransactions(product?.productID);


    const disableSave = !product.isDirty;

    if (!initialProduct || initialProduct === undefined || initialProduct.productID.length === 0) {
      navigate("/products/inventory");
    }

    return (
        <React.Fragment>
          <Toaster />
          <InfoCard>
            <InfoRow>
              <Label>{product.productName}</Label>
              <Value> {"("}{product.uom}{")"}  </Value>
            </InfoRow>
            <InfoRow>
              <Label>Quantité totale</Label>
              <Value>{product.quantityTotal}</Value>
            </InfoRow>
            <InfoRow>
              <Label>Quantité consommée</Label>
              <Value>{product.quantityConsumed}</Value>
            </InfoRow>
            <InfoRow>
              <Label>Quantité restante</Label>
              <Value>{product.quantity}</Value>
            </InfoRow>
            <InfoRow>
              <Label>Quantité programmée</Label>
              <Value>{product.quantityPlanned} </Value>
            </InfoRow>
          </InfoCard>

          <Row style={{marginTop: 40}}> 
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>Date</th>
                  <th style={{ width: "65%" }}>Designation</th>
                  <th style={{ width: "20%" }} className="text-right">Quantité</th>
                </tr>
              </thead>
              <tbody>  
                {transactions?.map((transaction : Transaction) => (
                  <InventoryProductTransactionCard {...transaction} key={transaction.id}/>
                ))}
              </tbody>
            </StyledTable> 
          </Row>

          <Row className="mt-4">
            <Col xs={12} className="text-center">
              <Link to="/products/inventory">
                <Button 
                  size="md" 
                  color="primary" 
                  className="px-4"
                >
                  Retour
                </Button>
              </Link>
            </Col>
          </Row>
               
        </React.Fragment>
    )
}
